module.exports = __webpack_public_path__ + "img/CowlarLogo.4fc9c071.svg";